import * as actionTypes from '../actions/actionTypes';
import * as api from 'api'
import { Item, Section, Page, Tag, Focus, Alert, Schedule } from 'schema'
import { ActionCreators } from 'redux-undo'; 
import _ from 'lodash'; 
import { itemContext, userContext } from 'context'
import { format, max, min, eachDayOfInterval, add, sub, set, isAfter, isEqual } from 'date-fns'
import { v4 as uuidv4 } from 'uuid';
import {ObjectId} from 'bson'
import {fromJS} from 'immutable'
import { datetimeString, getPlainText, initData } from 'utils';
import { pageContext } from 'context';
import moment from 'moment-timezone';
import store from '../store'

import React from 'react';
import { UpgradeModal } from 'features';
// test
export const setError = (error) => {
    return {
        type: actionTypes.ERROR,
        error: error
    }
}

export const timeTravel = (type, state, data, userId) => {
    // console.log('[timeTravel]',{type, state, data, userId})
    return dispatch => {        
        // Look for missing items or items to update
        let body = {
            pages: {create: [], updates: [], delete: []},
            sections: {create: [], updates: [], delete: []},
            items: {create: [], updates: [], delete: []}
        }

        for (const [key, value] of Object.entries({items: 'itemID', sections: 'sectionID', pages: 'pageID'})) {
            Object.values(state[key]).map(item => {
                // key === 'sections' && console.log({target:item, from:data[key][item[value]]})

                if(Object.keys(data[key]).includes(item[value])){
                    // Check for updates
                    !_.isEqual(item, data[key][item[value]]) && body[key]['updates'].push(item)
                    // JSON.stringify(item) !== JSON.stringify(data[key][item[value]]) && body[key]['updates'].push(item)
                } else {
                    // Create item
                    body[key]['create'].push(item)
                }
            })
    
            // Check for items to delete
            let createItems = Object.values(data[key]).length > 0 ? Object.values(data[key]).filter(item => !Object.keys(state[key]).includes(item[value])) : []
            if(createItems.length > 0){
                createItems.map(item => {
                    body[key]['delete'].push(item)
                })
            }
        }

        // [TODO] Commit changes to Mongo
        const commit = true
        commit && Promise.allSettled([
            // Create items
            body['items']['create'] && 
            Object.values(body['items']['create']).map(item => {
                let parents = Object.values(item['parents'])
                const parentType = parents.length > 0 ? 'item' : 'section'
                const parentID = parentType === 'section' ? item['sectionID'] : parents.slice(-1)[0]
                const parent = parentType === 'section' ? state['sections'][parentID] : state['items'][parentID]
                let updatedItem = {...item}
                updatedItem['_id'] = item['itemID']
                new Promise(resolve => {
                    api.createItem({item: updatedItem, userId: userId})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            }),
            
            // Update items
            body['items']['updates'] &&
            Object.values(body['items']['updates']).map(item => {
                new Promise(resolve => {
                    api.updateItem(item['itemID'], {userId: userId, updates: {...item}})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            }),

            // Delete items
            body['items']['delete'] && 
            Object.values(body['items']['delete']).map(item => {
                let parents = Object.values(item['parents'])
                const parentType = parents.length > 0 ? 'item' : 'section'
                const parentID = parentType === 'section' ? item['sectionID'] : parents.slice(-1)[0]
                const parent = parentType === 'section' ? state['sections'][parentID] : state['items'][parentID]
                new Promise(resolve => {
                    api.deleteItem(item['itemID'], {
                        parentID: parent[parentType === 'item' ? 'itemID' : 'sectionID'],
                        parentType: parentType,
                        userId
                    })
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            }),
            
            // Create section
            body['sections']['create'] && 
            Object.values(body['sections']['create']).map(section => {
                let updatedSection = {...section}
                updatedSection['_id'] = section['sectionID']
                new Promise(resolve => {
                    api.createSection(updatedSection)
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            }),

            // Update section
            body['sections']['updates'] && 
            Object.values(body['sections']['updates']).map(section => {
                new Promise(resolve => {
                    api.updateSection(section['sectionID'], {updates: {...section}})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            }),

            // Delete section
            body['sections']['delete'] && 
            Object.values(body['sections']['delete']).map(section => {
                new Promise(resolve => {
                    api.deleteSection(section['sectionID'], {page: data['pages'][section['pageID']]})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            }),

            // Update page
            body['pages']['updates'] && 
            Object.values(body['pages']['updates']).map(page => {
                new Promise(resolve => {
                    api.updatePage(page['pageID'], {updates: {...page}})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                })
            })

        ])
        .then(res => {
            console.log('Time travel done', res)
        })
        .catch(err => {
            console.log('Time travel failed', err)
        })

        // Commit action to reducer
        if(type === 'undo' && state.pages) {
            dispatch(ActionCreators.undo())
        } else if (type === 'redo' && state.pages) {
            dispatch(ActionCreators.redo())
        }
    }
}

export const getDataHandler = (data) => {
    console.log('[db.js] getData', data)
    return {
        type: actionTypes.GET_DATA,
        data: data
    }
}

export const getData = (userID) => {
    const debug = false
    let data = {
        pages: {},
        sections: {},
        items: {},
        tags: {},
        alerts: {},
        schedules: {},
    }
    debug && console.log('[getData]', {userID})
    return dispatch => {
        // Pages
        api.getPages({"filters": {createdBy: userID}}).then(pageRes => {
            const pages = pageRes.data['pages']
            const pageIDs = Object.values(pages).map(p => (p._id))
            Object.values(pages).map( i => {
                let page = new Page(i)
                page['pageID'] = i._id
                data['pages'][i._id] = page
            })

            return Promise.all([
                // Sections
                new Promise(resolve => {
                    api.getSections({"filters": {pageID: {"$in": pageIDs}}})
                    .then(res => {
                        res.data.success && Object.values(res.data['sections']).map( i => {
                            let section = new Section(i)
                            section['sectionID'] = i._id
                            data['sections'][i._id]  = section
                        })
                        resolve({ success: true })
                    })
                    .catch(err => {
                        debug && console.log('[getData] Failed to get sections', err)
                        resolve({ success: false, error: 'Failed to get sections' })
                    })
                }),
    
                // Items
                new Promise(resolve => {
                    api.getItems({"filters": {pageID: {"$in": pageIDs}}})
                    .then(res => {
                        console.log(res.data)
                        res.data.success && Object.values(res.data['items']).map( i => {
                            let item = new Item(i)
                            item['itemID'] = i._id
                            data['items'][i._id] = item
                        })
                        resolve({ success: true })
                    })
                    .catch(err => {
                        debug && console.log('[getData] Failed to get items')
                        resolve({ successs: false, error: 'Failed to get items' })
                    })
                }),

                // Tags
                new Promise(resolve => {
                    api.getTags({"filters": {pageID: {"$in": pageIDs}}})
                    .then(res => {
                        res.data.success && Object.values(res.data.tags).map( i => {
                            let tag = new Tag(i)
                            tag['tagID'] = i._id
                            data['tags'][i._id] = tag
                        })
                        resolve({ success: true })
                    })
                    .catch(err => {
                        debug && console.log('[getData] Failed to get tags')
                        resolve({ success: false, error: 'Failed to get tags' })
                    })
                }),

                // Alerts
                new Promise(resolve => {
                    api.getAlerts({"filters": {userID: userID}})
                    .then(res => {
                        const response = res.data.data
                        let alertData = {}
                        response && Object.values(response).map(a => {
                            let alert = new Alert(a)
                            alert['alertID'] = a._id
                            alertData[a._id] = alert
                        })
                        data['alerts'] = alertData
                        resolve({ success: true })
                    })
                    .catch(err => {
                        debug && console.log('[getData] Failed to get alerts')
                        resolve({ success: false, error: 'Failed to get alerts' })
                    })
                })
            ])
        })
        .then(res => {
            console.log('[db.js] getData', data)
            dispatch({
                type: actionTypes.GET_DATA,
                data: data
            })
        })
        .catch(err => {
            console.log('[db.js] getData failed', err)
        })
    }
}

export const updateData = data => {
    const debug = false
    return {
        type: actionTypes.UPDATE_DATA,
        data: data
    } 
}

export const commitDND = (data, item, parents, parentIndex, targetSectionID, userId, sessionId) => {
    const debug = true
    debug && console.log('[db.js] commitDND',{data:data, item:item, parents:parents, parentIndex: parentIndex, targetSectionID: targetSectionID, userId})
    const updatedBy = [userId, sessionId].join('@')
    let updatedData = {...data}
    let updatedItem = new Item({...item})
    const itemID = updatedItem['itemID']
    const sectionID = updatedItem['sectionID']
    const pageID = updatedItem['pageID']
    const oldParents = Object.values(updatedItem['parents'])
    const parentID = oldParents.length > 0 ? oldParents.slice(-1)[0] : sectionID
    const parentType = oldParents.length > 0 ? 'ITEM' : 'SECTION'

    return dispatch => {
        // ============================ //
        // Remove from initial position //
        // ============================ //
        let parent;
        let itemIDs;
        let childrenIDs;
        if(parentType === 'SECTION') {
            parent = {...updatedData['sections'][parentID]}
            itemIDs = {...parent['items']}
            let incompleteIDs = Object.values([...itemIDs['INCOMPLETE']])
            incompleteIDs = incompleteIDs.filter(id => updatedData['items'][id] ? (updatedData['items'][id]['sectionID'] == parentID && updatedData['items'][id]['status'] == 'INCOMPLETE') : false) 
            incompleteIDs.splice(incompleteIDs.indexOf(itemID), 1)
            itemIDs['INCOMPLETE'] = incompleteIDs
            parent['items'] = itemIDs
            updatedData['sections'][parentID] = parent
            // api.updateSection(parentID, {updates: {items: itemIDs}})
        } else if (parentType === 'ITEM') {
            parent = {...updatedData['items'][parentID]}
            childrenIDs = {...parent['children']}
            let incompleteIDs = Object.values([...childrenIDs['INCOMPLETE']])
            incompleteIDs = incompleteIDs.filter(id => updatedData['items'][id] && updatedData['items'][id]['status'] === itemContext.STATUS.INCOMPLETE)
            incompleteIDs.splice(incompleteIDs.indexOf(itemID), 1)
            childrenIDs['INCOMPLETE'] = incompleteIDs
            parent['children'] = childrenIDs
            updatedData['items'][parentID] = parent
            // api.updateItem(parentID, {updates: {children: childrenIDs}})
        }

        // ============ //
        //  Update item //
        // ============ //
        updatedItem['sectionID'] = targetSectionID
        updatedItem['parents'] = parents
        updatedData['items'][itemID] = updatedItem
        // api.updateItem(itemID, {updates: {sectionID: targetSectionID, parents: parents}})

        // ============================= //
        // Update remaining family items //
        // ============================= //
        let oldParentPrefix = Object.values(oldParents)
        let newParentPrefix = Object.values(parents).length === 0 ? []
                                : Object.values(parents).length > 0 ? Object.values(parents)
                                : null
        oldParentPrefix.push(itemID)
        newParentPrefix.push(itemID)
        const family = updatedItem.getFamily(true,updatedData)['all'] &&  Object.keys(updatedItem.getFamily(true,updatedData)['all'])
        let body = []
        family && family.map(childID => {
            let child = updatedData['items'][childID]
            let childParents = child['parents']
            childParents = newParentPrefix.concat(Object.values(child['parents']).filter(parentID => !oldParentPrefix.includes(parentID)))
            child['parents'] = childParents
            child['sectionID'] = targetSectionID
            updatedData['items'][childID] = child
            body.push({
                filter: {_id: child['itemID']},
                update: {parents: childParents, sectionID: targetSectionID}
            })
        })        
        // api.updateManyItems({entries: body})

        // =================== //
        //  Update new parent //
        // ================= //
        const newParentID = Object.values(parents).length > 0 ? Object.values(parents).slice(-1)[0] : targetSectionID
        const newParentType = Object.values(parents).length > 0 ? "ITEM" : "SECTION"
        let newParent;
        let newItemIDs;
        let newChildrenIDs;
        if(newParentType === 'SECTION'){
            newParent = {...updatedData['sections'][newParentID]}
            newItemIDs = {...newParent['items']}
            let newIncompleteIDs = Object.values([...newItemIDs['INCOMPLETE']])
            newIncompleteIDs = newIncompleteIDs.filter(id => updatedData['items'][id] ? (updatedData['items'][id]['sectionID'] == newParentID && updatedData['items'][id]['status'] == 'INCOMPLETE') : false) 
            newIncompleteIDs.splice(parentIndex, 0, itemID)
            newItemIDs['INCOMPLETE'] = newIncompleteIDs
            newParent['items'] = newItemIDs
            updatedData['sections'][newParentID] = new Section(newParent)
            // api.updateSection(newParentID, {updates: {items: newItemIDs}})
        } else if (newParentType === 'ITEM'){
            newParent = {...updatedData['items'][newParentID]}
            newChildrenIDs = {...newParent['children']}
            let newIncompleteIDs = Object.values([...newChildrenIDs['INCOMPLETE']])
            newIncompleteIDs = newIncompleteIDs.filter(id => updatedData['items'][id] && updatedData['items'][id]['status'] === itemContext.STATUS.INCOMPLETE)
            newIncompleteIDs.splice(parentIndex, 0, itemID)
            newChildrenIDs['INCOMPLETE'] = newIncompleteIDs
            newParent['children'] = newChildrenIDs
            updatedData['items'][newParentID] = new Item(newParent)
            // api.updateItem(newParentID, {updates: {children: newChildrenIDs}})
        }

        debug && console.log('[db.js] commitDND dispatch', updatedData)
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})
        
        // Commit to MongoDB
        Promise.all([
            parentType === 'SECTION' ? api.updateSection(parentID, {updates: {items: itemIDs, updatedBy: updatedBy}})
            : parentType === 'ITEM' ? api.updateItem(parentID, {userId: userId, updates: {children: childrenIDs, updatedBy}})
            : null,
            api.updateItem(itemID, {userId: userId, updates: {sectionID: targetSectionID, parents: parents, updatedBy: updatedBy}}),
            api.updateManyItems({entries: body, userId: userId, updatedBy: updatedBy}),
            newParentType === 'SECTION' ? api.updateSection(newParentID, {updates: {items: newItemIDs, updatedBy: updatedBy}})
            : newParentType === 'ITEM' ? api.updateItem(newParentID, {userId: userId, updates: {children: newChildrenIDs, updatedBy: updatedBy}})
            : null
        ])
        .then(res => {
            debug && console.log('CommitDND completed')
        })
        .catch(err => {
            debug && console.log('CommitDND failed', err)
            dispatch({type: actionTypes.ERROR, error: 'Item not created'})
        })
    }
}

export const commitDND2 = ({item, oldItem, items, data, userId, sessionId}) => {
    const debug = true
    const oldData = fromJS({...data})
    const updatedBy = [userId, sessionId].join('@')
    let updatedData = {...data}
    let activeId = item['id']

    let ref = { new: {}, old: {} }
    for (const [key, value] of Object.entries({ new: item, old: oldItem })) {
        ref[key]['item'] = value
        ref[key]['parentId'] = value['parents'].slice(-1)[0] || value['containerId']
        ref[key]['parentType'] = Object.keys(updatedData['sections']).includes(ref[key]['parentId']) ? 'SECTION' : 'ITEM'
        ref[key]['parent'] = updatedData[ref[key]['parentType'] === 'SECTION' ? 'sections' : 'items'][ref[key]['parentId']]
        ref[key]['sectionID'] = value['containerId']
        ref[key]['index'] = ref[key]['parent'][ref[key]['parentType'] === 'SECTION' ? 'items' : 'children']['INCOMPLETE'].indexOf(activeId)
        ref[key]['children'] = ref[key]['parent'][ref[key]['parentType'] === 'SECTION' ? 'items' : 'children']['INCOMPLETE']
    }

    // 1. Fix reference of the children for the new parent
    ref.new['children'] = items[ref.new['sectionID']].filter(itemId => [...ref.new['children'], activeId].includes(itemId))
    ref.new['index'] = ref.new['children'].indexOf(activeId)
    debug && console.log('[COMMIT_DND]',{item, oldItem, items, data, userId, sessionId, ref})

    // 2. Update active item
    let activeItem = updatedData['items'][activeId]
    activeItem['sectionID'] = ref.new['sectionID']
    activeItem['parents'] = ref.new['parentType'] === 'SECTION' ? []
                            : [...ref.new['parent']['parents'], ref.new['parentId']]

    // 3. Update children
    let children = Object.values(updatedData['items']).filter(item => item['parents'].includes(activeId))
    children = _.sortBy(children, (child) => { return child['parents'].length }) // Ensure seniors are updated first
    children.forEach(child => {
        child['sectionID'] = ref.new['sectionID']
        const childParentId = child['parents'].slice(-1)[0]
        child['parents'] = [...updatedData['items'][childParentId]['parents'], childParentId]
    })

    // 4. Remove from old parent
    if(ref.old['parentId'] !== ref.new['parentId']){
        ref.old['parent'][ref.old['parentType'] === 'SECTION' ? 'items' : 'children']['INCOMPLETE'].splice(ref.old['children'].indexOf(activeId), 1)
    }

    // 5. Insert into new parent
    ref.new['parent'][ref.new['parentType'] === 'SECTION' ? 'items' : 'children']['INCOMPLETE'] = ref.new['children']
    

    // 6. Commit to MongoDB
    return dispatch => {
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        Promise.all([
            // 6.1 Update old parent
            ref.old['parentType'] === 'SECTION' && ref.old['parentId'] !== ref.new['parentId'] ? api.updateSection(ref.old['parentId'], {updates: {items: ref.old.parent['items'], updatedBy: updatedBy}})
            : ref.old['parentType'] === 'ITEM' ? api.updateItem(ref.old['parentId'], {userId: userId, updates: {children: ref.old.parent['children'], updatedBy}})
            : null,

            // 6.2 Update active item
            api.updateItem(activeId, {userId: userId, updates: {sectionID: activeItem['sectionID'], parents: activeItem['parents'], updatedBy: updatedBy}}),

            // 6.3 Update children items
            children.length > 0 && api.updateManyItems({
                userId, 
                updatedBy,
                entries: children.map(child => ({
                    filter: {_id: child['itemID']},
                    update: {parents: child['parents'], sectionID: child['sectionID']}
                })), 
            }),

            // 6.4 Update new parent
            ref.new['parentType'] === 'SECTION' ? api.updateSection(ref.new['parentId'], {updates: {items: ref.new.parent['items'], updatedBy: updatedBy}})
            : ref.new['parentType'] === 'ITEM' ? api.updateItem(ref.new['parentId'], {userId: userId, updates: {children: ref.new.parent['children'], updatedBy: updatedBy}})
            : null
        ])
        .then(res => {
            debug && console.log('[COMMIT_DND] Completed')
        })
        .catch(err => {
            debug && console.log('[COMMIT_DND] Failed', err)
            dispatch({type: actionTypes.ERROR, error: 'Item not created'})
            dispatch({type: actionTypes.UPDATE_DATA, data: oldData.toJS()})
        })
    }
}

export const loadDeferred = (payload) => {
    const {
        data,
        pageID,
        deferred,
        loadCompleted
    } = payload
    const debug = false
    let updatedData = {...data}

    return dispatch => {
        api.loadUserExt({ 
            pageID, 
            loadCompleted,
            sectionIDs: deferred && deferred['sectionIDs'].join(',') 
        })
        .then(res => {
            debug && console.log('[loadDeferred] Completed', res.data)
            const output = initData(res.data)
            updatedData['items'] = {...updatedData.items, ...output.items}
            updatedData['alerts'] = {...updatedData.alerts, ...output.alerts}
            dispatch({
                type:actionTypes.UPDATE_DATA,
                data: updatedData,
                // loadedPages: pageID && [`${pageID}_COMPLETED`],
                deferred: {}
            })
            dispatch({
                type: actionTypes.LOAD_DEFERRED,
                deferredLoaded: true
            })
        })
        .catch(err => {
            console.log('[loadDeferred] Failed', err)
        })
    }
}

//////////
// ITEM //
//////////
export const createItem = (item, data, uid, user, sessionId) => {
    const oldData = fromJS({...data})
    const debug = false
    debug && console.log('Create item', {item: item, data: data})
    let updatedData = {...data}
    let updatedItem = {...item}
    updatedItem['createdBy'] = uid
    updatedItem['updatedBy'] = [uid, sessionId].join('@')
    const gotSchedule = (updatedItem['start_date'] || updatedItem['end_date'] || updatedItem['start_time'] || updatedItem['end_time']) && (Object.values(item['alerts']).length === 0)

    const parentType = Object.values(item['parents']).length > 0 ? 'item' : 'section'
    const parentID = parentType === 'item' ? Object.values(item['parents']).slice(-1)[0] : item['sectionID']
    let itemID = new ObjectId().toString();
    updatedItem['_id'] = itemID
    updatedItem['itemID'] = itemID
    let parent = parentType === 'item' ? updatedData['items'][parentID] : updatedData['sections'][parentID]
    let body
    let scheduleQueries = []

    return dispatch => {
        // 1. Add to schedule //
        if(gotSchedule){
            // Get range of dates
            let dates = _.compact(_.uniq([
                updatedItem['start_date'] && new Date(updatedItem['start_date']),
                updatedItem['end_date'] && new Date(updatedItem['end_date']),
                updatedItem['start_time']&& new Date(updatedItem['start_time']),
                updatedItem['end_time'] && new Date(updatedItem['end_time']),
            ]))
            if(dates.length > 0){
                const maxDate = new Date(max(dates)).setHours(0,0,0,0)
                const minDate = new Date(min(dates)).setHours(0,0,0,0)
                if(maxDate > minDate){
                    dates = eachDayOfInterval({
                        start: minDate,
                        end: maxDate
                    })
                }
            }
            dates = _.compact(_.uniq(dates.map(d => d && (format(d, 'LLL d Y')))))
            
            // Update or Create schedules
            let schedulesToUpdate = []
            let schedulesToCreate = []
            dates.map(schedule => {
                if(Object.keys(updatedData['schedules']).includes(schedule)){ // Update existing focus
                    let updatedSchedule = updatedData['schedules'][schedule]
                    if(!updatedSchedule['items'].includes(itemID)){ 
                        let scheduleItems = updatedSchedule['items']
                        scheduleItems.push(itemID)
                        updatedSchedule['items'] = scheduleItems
                        updatedData['schedules'][schedule] = updatedSchedule
                        schedulesToUpdate.push(updatedSchedule)
                    } 
                } else { // Create focus with item
                    let newScheduleID = new ObjectId().toString();
                    let newSchedule = new Schedule({scheduleID: newScheduleID, date: schedule, userID: uid, items: [itemID]})
                    updatedData['schedules'][schedule] = newSchedule
                    newSchedule['_id'] = newScheduleID
                    schedulesToCreate.push({...newSchedule})
                }
            })

            // Construct query for update focuses
            schedulesToUpdate.map(schedule => {
                scheduleQueries.push({
                    method: 'updateOne',
                    body: {
                        filter: {_id: schedule['scheduleID']},
                        update: {items: schedule['items']}
                    }
                })
            })
            schedulesToCreate.map(schedule => {
                scheduleQueries.push({
                    method: 'insertOne',
                    body: {
                        document: schedule
                    }
                })
            })
        }

        // 2. Create alert //
        if(gotSchedule){
            let alertID = new ObjectId().toString();
            let alert = new Alert({
                alertID: alertID, 
                userID: uid, 
                date: updatedItem['start_date'] || updatedItem['end_date'] || updatedItem['start_time'] || updatedItem['end_time'],
                title: getPlainText(item['content']), 
                subtitle: datetimeString(updatedItem['start_time'] || updatedItem['start_date'] || updatedItem['end_time'] || updatedItem['end_date']),
                secID: {id: itemID, relation: 'item'}})
            let alerts = Object.values(updatedItem['alerts'])
            alerts.push(alertID)
            updatedItem['alerts'] = alerts
            updatedData['alerts'][alertID] = alert

            body = {...alert}
            body['_id'] = alertID
        }

        // 3. Update data //
        updatedData['items'][itemID] = new Item(updatedItem)
        if(parentType === 'item'){
            let incompleteIDs = [...parent['children']['INCOMPLETE']] || []
            incompleteIDs.push(itemID)
            parent['children'] = {INCOMPLETE: incompleteIDs, COMPLETED: (parent['children']['COMPLETED'] || [])}
            updatedData['items'][parentID] = parent
        } else if (parentType === 'section'){
            let incompleteIDs = [...parent['items']['INCOMPLETE']] || []
            incompleteIDs.push(itemID)
            parent['items']['INCOMPLETE'] = incompleteIDs
            updatedData['sections'][parentID] = parent
        }
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})
        gotSchedule && dispatch({ type: actionTypes.UPDATE_ALERTS, alerts: [itemID] })

        const task = () => new Promise(resolve => {
            return api.countUserItems({userId: uid})
            .then(res => {
                const created = res.data['created'] + 1
                if(created > userContext.LIMITS.ITEM & user['subscription_plan'] === userContext.PLANS.PERSONAL){
                    dispatch({
                        type: actionTypes.SET_MODAL,
                        element: <UpgradeModal trigger='item'/>,
                        id: 'Upgrade'
                    })
                    dispatch({type: actionTypes.UPDATE_DATA, data: oldData.toJS()})
                    resolve({ success: true })
                } else {
                    return Promise.all([
                        // scheduleQueries.length > 0 && api.massSchedule({entries: scheduleQueries}),
                        body && api.createAlert(body),
                        api.createItem({item: updatedItem, userId: uid}),
                    ])
                    .then(itemRes => {
                        console.log('Item created', updatedItem)
                        resolve({ success: true })
                    })
                    .catch(err => {
                        console.log('Item not created', itemID)
                        dispatch({type: actionTypes.ERROR, error: 'Item not created', data: oldData.toJS()})
                        resolve({ success: false })
                    })
                }
            })
        })
        .then(res => {
            if(res['success']){
                dispatch({ type: 'INCREASE_QUEUE_INDEX'})
            } else {
                dispatch({ type: 'CLEAR_QUEUE_INDEX' })
                dispatch({ type: 'UPDATE_QUEUE', queue: [] })
            }
            // resolve()
        })
        .catch(err => {
            console.log(err)
            // resolve()
        })
        dispatch({type: actionTypes.UPDATE_QUEUE, task: task})
        // Commit to MongoDB
        // return api.countItems({userId: uid})
        // .then(res => {
        //     const created = res.data['created'] + 1
        //     if(created > userContext.LIMITS.ITEM & user['subscription_plan'] === userContext.PLANS.PERSONAL){
        //         dispatch({
        //             type: actionTypes.SET_MODAL,
        //             element: <UpgradeModal trigger='item'/>,
        //             id: 'Upgrade'
        //         })
        //         dispatch({type: actionTypes.UPDATE_DATA, data: oldData.toJS()})
        //     } else {
        //         Promise.all([
        //             // scheduleQueries.length > 0 && api.massSchedule({entries: scheduleQueries}),
        //             body && api.createAlert(body),
        //             api.createItem({item: updatedItem, userId: uid}),
        //         ])
        //         .then(itemRes => {
        //             console.log('Item created', updatedItem)
        //         })
        //         .catch(err => {
        //             console.log('Item not created', itemID)
        //             dispatch({type: actionTypes.ERROR, error: 'Item not created', data: oldData.toJS()})
        //         })
        //     }
        // })
    }
}

export const updateItem = (item, data, uid, sessionId) => {
    const oldData = fromJS(data)
    let updatedData = {...data}
    const itemID = item['itemID']
    let updatedItem = (({ details, item, ...o }) => o)(item)
    const updatedBy = [uid, sessionId].join('@')
    updatedItem['updatedBy'] = updatedBy
    const gotSchedule = (updatedItem['start_date'] || updatedItem['end_date'] || updatedItem['start_time'] || updatedItem['end_time'])
    const gotAlerts = Object.values(item['alerts']).length > 0
    let body
    let updatedAlerts = []
    let updateAlerts = false
    return dispatch => {
        // Create alert then update item
        if(gotSchedule){
            if(Object.values(item['alerts']).length > 0){
                updatedAlerts = Object.values(updatedItem['alerts']).filter(alertID => updatedData['alerts'][alertID]).map(alertID => {
                    let updatedAlert = updatedData['alerts'][alertID]
                    let option = {}
                    option[updatedAlert['reference']['metric']] = updatedAlert['reference']['value']
                    const refDate = updatedItem['start_time'] || updatedItem['start_date']
                    const subtitle = moment(refDate).format(updatedItem['start_time'] ? 'ddd, MMM D Y (h:mma)' : 'ddd, MMM D Y')
                    // const subtitle = schedule['start_date'].format('ddd, MMM D Y')
                    updatedAlert['date'] = updatedItem['start_time'] || updatedItem['start_date'] || updatedItem['end_time'] || updatedItem['end_date']
                    updatedAlert['subtitle'] = subtitle
                    updatedAlert['date'] = moment(updatedAlert['date']).toISOString()
                    updatedData['alerts'][alertID] = updatedAlert
                    updateAlerts = true
                    return updatedAlert
                })
            } else {
                let alertID = new ObjectId().toString();
                let alert = new Alert({
                    alertID: alertID, 
                    userID: uid, 
                    date: updatedItem['start_time'] || updatedItem['end_time'] || updatedItem['start_date'] || updatedItem['end_date'],
                    title: getPlainText(item['content']), 
                    subtitle: datetimeString(updatedItem['start_time'] || updatedItem['start_date'] || updatedItem['end_time'] || updatedItem['end_date']),
                    secID: {id: itemID, relation: 'item'}})
                let alerts = Object.values(updatedItem['alerts'])
                alerts.push(alertID)
                updatedItem['alerts'] = alerts
                updatedData['items'][itemID] = new Item(updatedItem)
                updatedData['alerts'][alertID] = alert

                body = {...alert}
                body['_id'] = alertID
                updateAlerts = true
            }
            
        } 
        updatedData['items'][itemID] = new Item(updatedItem)

        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})
        dispatch({type: actionTypes.SET_INPUT, inputID: null})
        updateAlerts && dispatch({ type: actionTypes.UPDATE_ALERTS, alerts: updatedData['alerts'] })
        
        // Commit to MongoDB
        const updateItemBody = {userId: uid, updates: {...updatedItem, updatedBy: updatedBy}}
        Promise.all(
            gotSchedule && !gotAlerts ? [api.createAlert(body), api.updateItem(itemID, updateItemBody)]
            : gotSchedule && updatedAlerts.length > 0 ? [updatedAlerts.map(a => api.updateAlert(a['alertID'], { updates: {...a} })), api.updateItem(itemID, updateItemBody)]
            : [api.updateItem(itemID, updateItemBody)]
        )
        .then(res => {
            console.log('Item updated', {updatedItem, gotSchedule, updatedAlerts, alerts: updatedData['alerts']})
        })
        .catch(err => {
            console.log('Item not updated', err)
            dispatch({type: actionTypes.ERROR, error: 'Item not created', data: oldData.toJS()})
        })
        
        
    }
}

export const updateItemSchedule = (alerts, item, data, uid, sessionId) => {
    const debug = false
    const oldData = fromJS(data)
    let updatedData = {...data}
    let updatedItem = {...item}
    const updatedBy = [uid, sessionId].join('@')
    updatedItem['updatedBy'] = updatedBy
    let updatedAlertIds = []
    return dispatch => {
        // Check for item alerts that are not created
        let newAlerts = alerts.filter(alert => !alert['alertID'])
        let oldAlerts = alerts.filter(alert => alert['alertID'])
        let delAlerts = item['alerts'].filter(alert => !Object.values(oldAlerts).some(oldAlert => oldAlert['alertID'] === alert) )

        // Create item alerts if need
        let newAlertIDs = []
        let newAlertBodies = {}
        newAlerts.map(newAlert => {
            const newAlertID = new ObjectId().toString()
            newAlertIDs.push(newAlertID)
            let body = {...newAlert}
            body['_id'] = newAlertID
            newAlertBodies[newAlertID] = body
            let updatedNewAlert = newAlert
            updatedNewAlert['alertID'] = newAlertID
            updatedData['alerts'][newAlertID] = new Alert(updatedNewAlert)
            updatedAlertIds.push(newAlertID)
        })

        // Update existing item alerts
        oldAlerts.map(oldAlert => {
            updatedData['alerts'][oldAlert['alertID']] = oldAlert
            updatedAlertIds.push(oldAlert['alertID'])
        })

        // Delete alerts if needed
        delAlerts.map(delAlertID => {
            updatedAlertIds.push(delAlertID)
            delete updatedData['alerts'][delAlertID]
        })
        
        // Update item [alerts & schedule dates]
        const alertIDs = newAlertIDs.concat(oldAlerts.map(oldAlert => (oldAlert['alertID'])))
        updatedItem['alerts'] = alertIDs
        updatedData['items'][item['itemID']] = new Item(updatedItem)
        // console.log('[updateItemSchedule]', updatedData['alerts'])
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})
        dispatch({ type: actionTypes.UPDATE_ALERTS, alerts: updatedAlertIds })
        // Commit to MongoDB
        // console.log({newAlerts, oldAlerts, updatedItem})
        Promise.all([
            // scheduleQueries.length > 0 && api.massSchedule({entries: scheduleQueries}),
            newAlertIDs.map(newAlertID => api.createAlert(newAlertBodies[newAlertID])),
            oldAlerts.map(oldAlert => {api.updateAlert(oldAlert['alertID'],{updates: {...oldAlert}})}),
            api.updateItem(item['itemID'], {
                userId: uid,
                updates: {
                    start_date: updatedItem['start_date'],
                    end_date: updatedItem['end_date'],
                    start_time: updatedItem['start_time'],
                    end_time: updatedItem['end_time'],
                    alerts: alertIDs,
                    updatedBy: updatedBy
                }
            }),
            delAlerts.length > 0 && api.deleteAlerts({alertIDs: delAlerts})
        ])
        .then(res => {
            debug && console.log('Schedule updated')
        })
        .catch(err => {
            console.log('Schedule not updated', err)
            dispatch({type: actionTypes.ERROR, error: 'Schedule not updated', data: oldData.toJS()})
        })
    }
}

export const deleteItem = (item, data, userId) => {
    const oldData = fromJS({...data})
    let updatedData = {...data}
    const itemID = item['itemID']
    const parentType = Object.values(item['parents']).length > 0 ? 'item' : 'section'
    const parentID = parentType === 'item' ? Object.values(item['parents']).slice(-1)[0] : item['sectionID']
    const oldParent = parentType === 'item' ? fromJS({...updatedData['items'][parentID]}) : fromJS({...updatedData['sections'][parentID]})
    let parent = parentType === 'item' ? {...updatedData['items'][parentID]} : {...updatedData['sections'][parentID]}

    return dispatch => {
        // 1. Remove relevant items
        updatedData['items'] =  _.omitBy(updatedData['items'], (item) => item['itemID'] === itemID)
        updatedData['items'] =  _.omitBy(updatedData['items'], (item) => item['parents'].includes(itemID))

        // 2. Remove alerts
        item['alerts'].length > 0 && item['alerts'].map(alert => {
            delete updatedData['alerts'][alert]
        })

        // 3. Remove schedules
        let schedulesToUpdate = []
        const dates = item.getScheduleRange()

        // 3a. Remove item from schedules
        dates.map(schedule => {
            if(Object.keys(updatedData['schedules']).includes(schedule)){ // Update existing focus
                let updatedSchedule = updatedData['schedules'][schedule]
                if(updatedSchedule['items'].includes(itemID)){ 
                    let scheduleItems = updatedSchedule['items']
                    _.pull(scheduleItems, itemID)
                    updatedSchedule['items'] = scheduleItems
                    updatedData['schedules'][schedule] = updatedSchedule
                    schedulesToUpdate.push(updatedSchedule)
                } 
            }
        })

        // 3b. Construct query for update focuses
        let scheduleQueries = []
        schedulesToUpdate.map(schedule => {
            scheduleQueries.push({
                method: 'updateOne',
                body: {
                    filter: {_id: schedule['scheduleID']},
                    update: {items: schedule['items']}
                }
            })
        })

        // 4. Update parent
        if(parentType === 'item'){
            let childrenIDs = parent['children']
            let incomplete = Object.values([...childrenIDs['INCOMPLETE']])
            let completed = Object.values([...childrenIDs['COMPLETED']])
            incomplete.indexOf(itemID) >= 0 && incomplete.splice(incomplete.indexOf(itemID), 1)
            completed.indexOf(itemID) >= 0 && completed.splice(completed.indexOf(itemID), 1)
            childrenIDs = {
                INCOMPLETE: incomplete,
                COMPLETED: completed
            }
            parent['children'] = childrenIDs
            updatedData['items'][parentID] = new Item(parent)
        } else if (parentType === 'section'){
            let childrenIDs = parent['items']
            let incomplete = Object.values([...childrenIDs['INCOMPLETE']])
            let completed = Object.values([...childrenIDs['COMPLETED']])
            incomplete.indexOf(itemID) >= 0 && incomplete.splice(incomplete.indexOf(itemID), 1)
            completed.indexOf(itemID) >= 0 && completed.splice(completed.indexOf(itemID), 1)
            childrenIDs = {
                INCOMPLETE: incomplete,
                COMPLETED: completed
            }
            parent['items'] = childrenIDs
            updatedData['sections'][parentID] = new Section(parent)
        }
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        // Commit MongoDB
        Promise.all([
            // api.deleteItem(itemID, {parent: oldParent.toJS()}),
            api.deleteItem(itemID, {
                parentID: oldParent.toJS()[parentType === 'item' ? 'itemID' : 'sectionID'],
                parentType: parentType,
                userId: userId
            }),
            item['alerts'].length > 0 && api.deleteAlerts({alertIDs: item['alerts']}),
            // scheduleQueries.length > 0 && api.massSchedule({entries: scheduleQueries}),
        ])
        .then(res => {
            console.log('Item deleted', itemID)
        })
        .catch(err => {
            console.log('Item not deleted', itemID)
            dispatch({type: actionTypes.ERROR, error: 'Item not created', data: oldData.toJS()})
        })
    }
}

export const updateItemStatus = (item, data, userId, sessionId) => {
    // console.log('ITEM', item)
    const oldData = fromJS({...data})
    let updatedData = {...data}
    let updatedItem = new Item({...item})
    const updatedBy = [userId, sessionId].join('@')
    updatedItem['updatedBy'] = updatedBy
    const oldStatus = updatedItem['status']
    const newStatus = oldStatus === itemContext.STATUS.INCOMPLETE ? itemContext.STATUS.COMPLETED : itemContext.STATUS.INCOMPLETE
    // const family = Object.values(updatedItem.getFamily(oldStatus === itemContext.STATUS.COMPLETED,updatedData)[oldStatus.toLowerCase()]['keys'])
    const family = Object.keys(updatedItem.getFamily(oldStatus === itemContext.STATUS.COMPLETED,updatedData))

    const itemID = updatedItem['itemID']
    const completed_date = newStatus === itemContext.STATUS.COMPLETED ? new Date() : null

    return dispatch => {
        // Update item
        updatedItem['status'] = newStatus
        updatedItem['completed_date'] = completed_date
        let children = updatedItem['children']
        let incomplete = [...children['INCOMPLETE']] || []
        let completed = [...children['COMPLETED']] || []
        if(newStatus === 'COMPLETED'){
            completed.push(...incomplete)
            incomplete = []
        } else if (newStatus === 'INCOMPLETE'){
            incomplete.push(...completed)
            completed = []
        }
        updatedItem['children'] = {INCOMPLETE: incomplete, COMPLETED: completed}
        updatedData['items'][itemID] = new Item({...updatedItem})
        const itemUpdates = { status: newStatus, children: updatedItem['children'], completed_date: completed_date, updatedBy: updatedBy }

        let body = []
        // body.push({filter: {_id: itemID}, update: {status: newStatus, children: updatedItem['children'], completed_date: completed_date}})

        // Update children
        family.map(childID => {
            let child = new Item({...updatedData['items'][childID]})
            let gc = child['children']
            let gcIncomplete = gc['INCOMPLETE']
            let gcCompleted = gc['COMPLETED']
            if(newStatus === 'COMPLETED'){
                gcCompleted.push(...gcIncomplete)
                gcIncomplete = []
            } else if (newStatus === 'INCOMPLETE'){
                gcIncomplete.push(...gcCompleted)
                gcCompleted = []
            }
            gc = {INCOMPLETE: gcIncomplete, COMPLETED: gcCompleted}
            child['children'] = gc
            child['status'] = newStatus
            updatedData['items'][childID] = new Item({...child})
            body.push({filter: {_id: childID}, update: {status: newStatus, children: gc, completed_date: completed_date, updatedBy: updatedBy}})
        })

        // Update parent
        let parent;
        let itemIDs;
        let childrenIDs;
        const parents = Object.values(updatedItem['parents'])
        const parentID = parents.length > 0 ? parents.slice(-1)[0] : updatedItem['sectionID']
        const parentType = parents.length > 0 ? 'ITEM' : 'SECTION'

        if(parentType === 'SECTION') {
            parent = {...updatedData['sections'][parentID]}
            itemIDs = parent['items']
            let incomplete = Object.values(itemIDs['INCOMPLETE'])
            let completed = Object.values(itemIDs['COMPLETED'])
            if(newStatus === 'COMPLETED'){
                incomplete.splice(incomplete.indexOf(itemID), 1)
                completed.push(itemID)
            } else {
                completed.splice(completed.indexOf(itemID), 1)
                incomplete.push(itemID)
            }
            
            itemIDs = {INCOMPLETE: incomplete, COMPLETED: completed}
            parent['items'] = itemIDs
            updatedData['sections'][parentID] = new Section(parent)
        } 
        
        else if (parentType === 'ITEM') {
            parent = {...updatedData['items'][parentID]}
            childrenIDs = parent['children']
            let incomplete = Object.values(childrenIDs['INCOMPLETE'])
            let completed = Object.values(childrenIDs['COMPLETED'])
            if(newStatus === 'COMPLETED'){
                incomplete.splice(incomplete.indexOf(itemID), 1)
                completed.push(itemID)
            } else {
                completed.splice(completed.indexOf(itemID), 1)
                incomplete.push(itemID)
            }
            
            childrenIDs = {INCOMPLETE: incomplete, COMPLETED: completed}
            parent['children'] = childrenIDs
            updatedData['items'][parentID] = new Item(parent)
        }

        // Uncheck all parents if new status is incomplete [Child item only]
        let parentsBody = []
        if(newStatus === 'INCOMPLETE'){

            updatedItem['parents'].map((pid, index) => {

                // Change parent item status
                let p = updatedData['items'][pid]
                if(p['status'] !== 'INCOMPLETE'){
                    p['status'] = 'INCOMPLETE'
                    updatedData['items'][pid] = p
        
                    // Update grandparent item
                    let gpIDs = p['parents']
                    const gpType = gpIDs.length > 0 ? 'ITEM' : 'SECTION'
                    const gpID = gpType === 'SECTION' ? p['sectionID'] : p['parents'].slice(-1)[0]

                    if(gpType === 'SECTION'){
                        let gp = {...updatedData['sections'][gpID]}
                        itemIDs = gp['items']
                        let incomplete = Object.values(itemIDs['INCOMPLETE'])
                        let completed = Object.values(itemIDs['COMPLETED'])
                        completed.splice(completed.indexOf(pid), 1)
                        !incomplete.includes(pid) && incomplete.push(pid)
                        itemIDs = {INCOMPLETE: incomplete, COMPLETED: completed}
                        gp['items'] = itemIDs
                        updatedData['sections'][gpID] = new Section(gp)
    
                    } else if (gpType === 'ITEM'){
                        let gp = {...updatedData['items'][gpID]}
                        let gChildrenIDs = gp['children']
                        let incomplete = Object.values(gChildrenIDs['INCOMPLETE'])
                        let completed = Object.values(gChildrenIDs['COMPLETED'])
                        completed.splice(completed.indexOf(pid), 1)
                        !incomplete.includes(pid) && incomplete.push(pid)
                        gChildrenIDs = {INCOMPLETE: incomplete, COMPLETED: completed}
                        gp['children'] = gChildrenIDs
                        updatedData['items'][gpID] = new Item(gp)
    
                        parentsBody.push({filter: {_id: gpID}, update: {status: newStatus, children: gChildrenIDs, completed_date: completed_date, updatedBy: updatedBy}})
                    }
                }
            })
        }

        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        // Commit to MongoDB
        return Promise.allSettled([
            new Promise(resolve => {
                if(parentType === 'ITEM' & newStatus === 'INCOMPLETE'){
                    return Promise.allSettled([
                        api.updateItem(parentID, {userId: userId, updates: {children: childrenIDs, status: newStatus, updatedBy: updatedBy}}),
                        api.updateSection(parentID, {updates: {items: itemIDs, updatedBy: updatedBy}}),
                        api.updateManyItems({entries: parentsBody, userId: userId})
                    ])
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                } else if(parentType === 'ITEM'){
                    api.updateItem(parentID, {userId: userId, updates: {children: childrenIDs, updatedBy: updatedBy}})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                } else if (parentType === 'SECTION') {
                    api.updateSection(parentID, {updates: {items: itemIDs, updatedBy: updatedBy}})
                    .then(res => resolve({ success: true }))
                    .catch(err => resolve({ success: false }))
                }
            }),
            new Promise(resolve => {
                api.updateItem(itemID, { userId: userId, updates: itemUpdates, updatedBy: updatedBy })
                .then(res => resolve({ success: true }))
                .catch(err => resolve({ success: false }))
            }),
            new Promise(resolve => {
                api.updateManyItems({entries: body, userId: userId})
                .then(res => resolve({ success: true }))
                .catch(err => resolve({ success: false }))
            })
        ])
        .then(res => {
            const outcomes = res.map(call => call.value['success'])
            console.log('[updateItemStatus] Completed', outcomes)
            if(outcomes.some(v => v === false)){
                dispatch({type: actionTypes.ERROR, error: 'Item status not updated', data: oldData.toJS()})
            }
        })
        .catch(err => {
            console.log('[updateItemStatus] Failed', err)
            dispatch({type: actionTypes.ERROR, error: 'Item status not updated', data: oldData.toJS()})
        })
    }
}

export const shiftItem = (data, item, parents, parentIndex, targetSectionID, targetPageID, userId, sessionId) => {
    const debug = false
    debug && console.log('[db.js] shiftItem',{data:data, item:item, parents:parents, parentIndex: parentIndex, targetSectionID, targetPageID})
    let updatedData = {...data}
    let updatedItem = new Item({...item})
    const itemID = updatedItem['itemID']
    const sectionID = updatedItem['sectionID']
    const pageID = updatedItem['pageID']
    const updatedBy = [userId, sessionId].join('@')
    const oldParents = Object.values(updatedItem['parents'])
    const parentID = oldParents.length > 0 ? oldParents.slice(-1)[0] : sectionID
    const parentType = oldParents.length > 0 ? 'ITEM' : 'SECTION'

    return dispatch => {
        // ============================ //
        // Remove from initial position //
        // ============================ //
        let parent;
        let itemIDs;
        let childrenIDs;
        if(parentType === 'SECTION') {
            parent = {...updatedData['sections'][parentID]}
            itemIDs = {...parent['items']}
            let incompleteIDs = Object.values([...itemIDs['INCOMPLETE']])
            incompleteIDs.splice(incompleteIDs.indexOf(itemID), 1)
            itemIDs['INCOMPLETE'] = incompleteIDs
            parent['items'] = itemIDs
            updatedData['sections'][parentID] = parent
            // api.updateSection(parentID, {updates: {items: itemIDs}})
        } else if (parentType === 'ITEM') {
            parent = {...updatedData['items'][parentID]}
            childrenIDs = {...parent['children']}
            let incompleteIDs = Object.values([...childrenIDs['INCOMPLETE']])
            incompleteIDs.splice(incompleteIDs.indexOf(itemID), 1)
            childrenIDs['INCOMPLETE'] = incompleteIDs
            parent['children'] = childrenIDs
            updatedData['items'][parentID] = parent
            // api.updateItem(parentID, {updates: {children: childrenIDs}})
        }

        // ============ //
        //  Update item //
        // ============ //
        updatedItem['sectionID'] = targetSectionID
        updatedItem['pageID'] = targetPageID
        updatedItem['parents'] = parents
        updatedItem['updatedBy'] = updatedBy
        updatedData['items'][itemID] = updatedItem

        // ============================= //
        // Update remaining family items //
        // ============================= //
        let oldParentPrefix = Object.values(oldParents)
        let newParentPrefix = Object.values(parents).length === 0 ? []
                                : Object.values(parents).length > 0 ? Object.values(parents)
                                : null
        oldParentPrefix.push(itemID)
        newParentPrefix.push(itemID)
        const family = updatedItem.getFamily(true,updatedData)['all'] &&  Object.keys(updatedItem.getFamily(true,updatedData)['all'])
        let body = []
        family && family.map(childID => {
            let child = updatedData['items'][childID]
            let childParents = child['parents']
            childParents = newParentPrefix.concat(Object.values(child['parents']).filter(parentID => !oldParentPrefix.includes(parentID)))
            child['parents'] = childParents
            child['sectionID'] = targetSectionID
            child['pageID'] = targetPageID
            updatedData['items'][childID] = child
            body.push({
                filter: {_id: child['itemID']},
                update: {parents: childParents, sectionID: targetSectionID, pageID: targetPageID, updatedBy: updatedBy}
            })
        })        
        // api.updateManyItems({entries: body})

        // =================== //
        //  Update new parent //
        // ================= //
        const newParentID = Object.values(parents).length > 0 ? Object.values(parents).slice(-1)[0] : targetSectionID
        const newParentType = Object.values(parents).length > 0 ? "ITEM" : "SECTION"
        let newParent;
        let newItemIDs;
        let newChildrenIDs;
        if(newParentType === 'SECTION'){
            newParent = {...updatedData['sections'][newParentID]}
            newItemIDs = {...newParent['items']}
            let newIncompleteIDs = Object.values([...newItemIDs['INCOMPLETE']])
            newIncompleteIDs.splice(parentIndex, 0, itemID)
            newItemIDs['INCOMPLETE'] = newIncompleteIDs
            newParent['items'] = newItemIDs
            updatedData['sections'][newParentID] = new Section(newParent)
            // api.updateSection(newParentID, {updates: {items: newItemIDs}})
        } else if (newParentType === 'ITEM'){
            newParent = {...updatedData['items'][newParentID]}
            newChildrenIDs = {...newParent['children']}
            let newIncompleteIDs = Object.values([...newChildrenIDs['INCOMPLETE']])
            newIncompleteIDs.splice(parentIndex, 0, itemID)
            newChildrenIDs['INCOMPLETE'] = newIncompleteIDs
            newParent['children'] = newChildrenIDs
            updatedData['items'][newParentID] = new Item(newParent)
            // api.updateItem(newParentID, {updates: {children: newChildrenIDs}})
        }

        debug && console.log('[db.js] shiftItem dispatch', updatedData)
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})
        
        // Commit to MongoDB
        Promise.all([
            parentType === 'SECTION' ? api.updateSection(parentID, {updates: {items: itemIDs, updatedBy: updatedBy}})
            : parentType === 'ITEM' ? api.updateItem(parentID, {userId: userId, updates: {children: childrenIDs, updatedBy: updatedBy}})
            : null,
            api.updateItem(itemID, {userId: userId, updates: {sectionID: targetSectionID, pageID: targetPageID, parents: parents, updatedBy: updatedBy}}),
            api.updateManyItems({entries: body, userId: userId}),
            newParentType === 'SECTION' ? api.updateSection(newParentID, {updates: {items: newItemIDs, updatedBy: updatedBy}})
            : newParentType === 'ITEM' ? api.updateItem(newParentID, {userId: userId, updates: {children: newChildrenIDs, updatedBy: updatedBy}})
            : null
        ])
        .then(res => {
            debug && console.log('Shift item completed')
        })
        .catch(err => {
            console.log('Shift item failed', err)
            dispatch({type: actionTypes.ERROR, error: 'Item not shifted'})
        })
    }
}

//////////////
// SECTION //
/////////////
export const createSection = (section, data, id, page, sessionId) => {
    const debug = false
    debug && console.log('[db.js] createSection', section, data, id)
    const oldData = fromJS(data)
    let updatedData = {...data}
    let updatedSection = new Section(section)
    const targetSectionID = id && id.replace('_SectionInput', '')
    const pageID = section['pageID']
    let sectionIDs = [...updatedData['pages'][pageID]['sections']]
    const targetIndex = !targetSectionID ? 0 : sectionIDs.indexOf(targetSectionID)
    const sectionID = new ObjectId().toString();
    const userId = section['createdBy']
    const updatedBy = [userId, sessionId].join('@')
    let updatedPage = page
    
    return dispatch => {
        // Create section
        updatedSection['sectionID'] = sectionID
        updatedSection['_id'] = sectionID
        updatedSection['updatedBy'] = updatedBy
        updatedData['sections'][sectionID] = new Section(updatedSection)

        // Update page
        sectionIDs.splice(targetIndex + 1, 0, sectionID)
        updatedPage['sections'] = sectionIDs
        updatedData['pages'][pageID] = updatedPage
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        // Commit to MongoDB
        Promise.all([
            api.createSection(updatedSection),
            api.updatePage(pageID, {updates: {sections: sectionIDs, updatedBy: updatedBy}})
        ])
        .then(res => {
            debug && console.log('Section created', updatedData)
        })
        .catch(err => {
            console.log('Section not created')
            dispatch({type: actionTypes.ERROR, error: 'Item not created', data: oldData.toJS()})
        })
    }
}

export const updateSection = (section, data, userId, sessionId) => {
    const oldData = fromJS(data)
    let updatedData = {...data}
    let updatedSection = section
    const updatedBy = [userId, sessionId].join('@')
    updatedSection['updatedBy'] = updatedBy

    return dispatch => {
        // Update data
        updatedData['sections'][section['sectionID']] = updatedSection
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        // Commit MongoDB
        const body = {...updatedSection, updatedBy: updatedBy}

        api.updateSection(section['sectionID'], {updates: body})
        .then(res => {
            console.log('Section updated')
        })
        .catch(err => {
            console.log('Update section failed')
            dispatch({type: actionTypes.ERROR, error: 'Section not updated', data: oldData.toJS()})
        })
        
    }
}

export const deleteSection = (section, data, page) => {
    const debug = false
    const oldData = fromJS(data)
    let updatedData = {...data}
    const sectionID = section['sectionID']
    const pageID = section['pageID']
    const oldPage = fromJS({...updatedData['pages'][pageID]})
    // let page = data['pages'][pageID]
    return dispatch => {
        // Remove section and items
        updatedData['sections'] = _.omitBy(updatedData['sections'], (section) => section['sectionID'] === sectionID)
        updatedData['items'] =  _.omitBy(updatedData['items'], (item) => item['sectionID'] === sectionID)

        // Update page
        let updatedPage = {...page}
        let sections = Object.values(updatedPage['sections'])
        sections.splice(sections.indexOf(sectionID), 1)
        updatedPage['sections'] = sections
        updatedData['pages'][pageID] = updatedPage
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        // Commit to MongoDB
        api.deleteSection(sectionID, {page: oldPage.toJS()})
        .then(res => {
            debug && console.log('Section deleted', updatedData)
        })
        .catch(err => {
            console.log('Section not deleted', err)
            dispatch({type: actionTypes.ERROR, error: 'Section not deleted', data: oldData.toJS()})
        })
    }
}

export const shiftSection = (data, section, targetPageID, userId, sessionId) => {
    let updatedData = {...data}
    const oldPageID = section['pageID']
    const oldData = fromJS(data)
    const updatedBy = [userId, sessionId].join('@')
    // console.log('[db.js] shiftSection', {section: section, data: data, pageID: targetPageID})

    // 1. Update section
    let updatedSection = {...section}
    const sectionID = updatedSection['sectionID']
    updatedSection['pageID'] = targetPageID
    updatedSection['updatedBy'] = updatedBy
    updatedData['sections'][sectionID] = updatedSection

    // 2. Update new page
    let newPage = {...updatedData['pages'][targetPageID]}
    let newSectionIDs = newPage['sections']
    newSectionIDs.push(sectionID)
    newPage['sections'] = newSectionIDs
    newPage['updatedBy'] = updatedBy
    updatedData['pages'][targetPageID] = new Page(newPage)

    // 3. Update old page
    let oldPage = {...updatedData['pages'][oldPageID]}
    let oldSectionIDs = oldPage['sections']
    oldSectionIDs.splice(oldSectionIDs.indexOf(sectionID), 1)
    oldPage['sections'] = oldSectionIDs
    oldPage['updatedBy'] = updatedBy
    updatedData['pages'][oldPageID] = new Page(oldPage)

    // 4. Update items
    const items = _.filter(updatedData['items'], {sectionID: sectionID})
    let body = []
    items.map(item => {
        let updatedItem = {...item}
        updatedItem['pageID'] = targetPageID
        updatedData['items'][updatedItem['itemID']] = updatedItem
        body.push({
            filter: {_id: updatedItem['itemID']}, 
            update: {pageID: targetPageID, updatedBy: updatedBy}
        })
    })

    // 5. Commit to MongoDB
    return dispatch => {
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        Promise.all([
            api.updatePage(oldPageID, {updates: {sections: oldSectionIDs, updatedBy: updatedBy}}),
            api.updatePage(targetPageID, {updates: {sections: newSectionIDs, updatedBy: updatedBy}}),
            api.updateSection(sectionID, {updates: {...updatedSection, updatedBy: updatedBy}}),
            api.updateManyItems({entries: body, userId: userId})
        ])
        .then(res => {
            console.log('Shift section completed')
        })
        .catch(err => {
            console.log('Shift section failed', err)
            dispatch({type: actionTypes.ERROR, data: oldData, error: 'Shift section failed'})
        })
    }

}


///////////
// PAGE //
//////////
export const loadPage = (pageID, statuses, data) => {
    const debug = false
    let updatedData = {...data}
    debug && console.log('[loadPage]',{pageID, statuses, data})
    return dispatch => {
        api.loadPage(pageID, { statuses })
        .then(pageRes => {
            if(pageRes.data['page']){
                let items = pageRes.data['items']
                let sections = pageRes.data['sections']
                for (const [itemID, item] of Object.entries(items)) {
                    updatedData['items'][itemID] = new Item(item)
                }

                for (const [sectionID, section] of Object.entries(sections)) {
                    updatedData['sections'][sectionID] = new Section(section)
                }
                updatedData['pages'][pageID] = new Page(pageRes.data['page'])
                dispatch({
                    type:actionTypes.UPDATE_DATA,
                    data: updatedData,
                    loadedPages: pageRes.data['loadedPages']
                }) 
            }
            
        })  
    }
}

export const createPage = (page, data, user, sessionId) => {
    const debug = true
    const oldData = fromJS(data)
    const oldUser = {...user}
    let updatedData = {...data}
    let updatedPage = {...page}
    const pageID = new ObjectId().toString();
    const sectionID = new ObjectId().toString();
    const updatedBy = [user['uid'], sessionId].join('@')
    updatedPage['createdBy'] = user['uid']
    updatedPage['updatedBy'] = updatedBy
    updatedPage['pageID'] = pageID
    updatedPage['_id'] = pageID
    return dispatch => {
        const body = {
            page: updatedPage,
            user: user,
            sectionID: sectionID
        }

        // Create page and section
        const section = new Section({sectionID: sectionID, section_name: 'Unassigned items', pageID: pageID, createdBy: user['uid'], updatedBy: updatedBy})
        updatedData['sections'][sectionID] = section
        updatedPage['sections'] = [sectionID]
        updatedData['pages'][pageID] = new Page(updatedPage)

        // Update user
        let updatedUser = {...user}
        let activePageIDs = updatedUser['activePages']
        activePageIDs.push(pageID)
        updatedUser['activePageIDs'] = pageID
        updatedUser['activePageID'] = pageID
        updatedUser['activePageType'] = 'Pages'

        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData, loadedPages: [`${pageID}_INCOMPLETE`, `${pageID}_COMPLETED`]})
        dispatch({type: actionTypes.UPDATE_USER, user: updatedUser})

        
        api.countPages({ userId: user['uid'] })
        .then(countRes => {
            const created = countRes.data['created']
            console.log({created})
            if(created > userContext.LIMITS.PAGE & user['subscription_plan'] === userContext.PLANS.PERSONAL){
                dispatch({
                    type: actionTypes.SET_MODAL,
                    element: <UpgradeModal trigger='page'/>,
                    id: 'Upgrade'
                })
                dispatch({type: actionTypes.UPDATE_DATA, data: oldData.toJS()})
                dispatch({type: actionTypes.UPDATE_USER, user: oldUser})
            } else {
                // Commit MongoDB
                api.createPage(body)
                .then(res => {
                    debug && console.log('Page created', {page: updatedPage, data: updatedData})
                })
                .catch(err => {
                    debug && console.log('Page not created')
                    dispatch({type: actionTypes.ERROR, error: 'Page not created', data: oldData.toJS()})
                })
            }
        })
        .catch(countErr => {

        })

        
    }
}

export const updatePageStatus = (page, data, user, sessionId) => {
    const oldData = fromJS(data)
    const oldUser = fromJS(user)
    let updatedData = {...data}
    let updatedUser = {...user}
    let updatedPage = page
    const newStatus = page['status']
    const oldStatus = page['status'] === pageContext.STATUS.ACTIVE ? pageContext.STATUS.ARCHIVE : pageContext.STATUS.ACTIVE
    const pageID = page['pageID']
    const updatedBy = [user['uid'], sessionId].join('@')
    updatedPage['updatedBy'] = updatedBy
    return dispatch => {
        // Update page data
        updatedData['pages'][page['pageID']] = updatedPage

        // Update user
        let active = updatedUser['activePages']
        let archived = updatedUser['archivePages']
        if(newStatus === pageContext.STATUS.ARCHIVE){
            active.splice(active.indexOf(pageID), 1)
            archived.unshift(pageID)
        } else {
            archived.splice(archived.indexOf(pageID), 1)
            active.unshift(pageID)
        }
        updatedUser['activePages'] = active
        updatedUser['archivePages'] = archived

        // Get next activePageID
        let nextPageID;
        let nextPageType = updatedUser['activePageType']
        if(pageID !== updatedUser['activePageID']){
            nextPageID = updatedUser['activePageID']
        } else {
            if(updatedUser['activePages'].length > 0){
                nextPageID = updatedUser['activePages'][0]
            } else {
                nextPageID = 'FOCUS'
                nextPageType = 'Modules'
            }
        }
        updatedUser['activePageID'] = nextPageID
        updatedUser['activePageType'] = nextPageType

        dispatch({type: actionTypes.COMMIT_DATA, data: updatedData})
        dispatch({type: actionTypes.UPDATE_USER, user: updatedUser})
        console.log({page: page, data: updatedData, user: updatedUser})

        // Commit MongoDB
        Promise.all([
            api.updatePage(pageID, {updates: {...page, updatedBy: updatedBy}}),
            api.updateUser(user.uid, {updates: updatedUser})
        ])
        .then(res => {
            console.log('Page status changed')
        })
        .catch(err => {
            console.log('Page status not changed')
            dispatch({type: actionTypes.ERROR, error: 'Page status not updated', data: oldData.toJS()})
            dispatch({type: actionTypes.UPDATE_USER, user: oldUser})
        })
    }
}

export const updatePage = (page, data, userId, sessionId) => {
    const oldData = fromJS(data)
    let updatedData = {...data}
    let updatedPage = page
    const updatedBy = [userId, sessionId].join('@')
    updatedPage['updatedBy'] = updatedBy
    updatedData['pages'][page.pageID] = updatedPage
    const body = {updates: {...updatedPage, updatedBy: updatedBy}}

    return dispatch => {
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        page.pageID && api.updatePage(page.pageID, body)
            .then(res => {
                console.log('Page updated')
            })
            .catch(err => {
                console.log('Page not updated', err)
                dispatch({type: actionTypes.ERROR, error: 'Page not updated', data: oldData.toJS()})
            })
    }
}

export const deletePage = (pageID, data, user) => {
    let updatedData = {...data}
    const oldData = fromJS(data)

    return dispatch => {
        // Remove page items and sections
        updatedData['pages'] = _.omitBy(updatedData['pages'], (page) => page['pageID'] === pageID)
        updatedData['sections'] = _.omitBy(updatedData['sections'], (section) => section['pageID'] === pageID)
        updatedData['items'] =  _.omitBy(updatedData['items'], (item) => item['pageID'] === pageID)

        // Update pageIDs
        let activePageIDs = user['activePages'] ? Object.values(user['activePages']) : []
        let archivePageIDs = user['archivePages'] ? Object.values(user['archivePages']) : []
        activePageIDs.indexOf(pageID) >= 0 && activePageIDs.splice(activePageIDs.indexOf(pageID), 1)
        archivePageIDs.indexOf(pageID) >= 0 && archivePageIDs.splice(archivePageIDs.indexOf(pageID), 1)

        // Get next activePageID
        let nextPageID;
        let nextPageType = user['activePageType']
        if(pageID !== user['activePageID']){
            nextPageID = user['activePageID']
        } else {
            if(activePageIDs.length > 0){
                nextPageID = activePageIDs[0]
            } else {
                nextPageID = 'FOCUS'
                nextPageType = 'Modules'
            }
        }

        // Update user
        let updatedUser = {...user}
        updatedUser['activePageID'] = nextPageID
        updatedUser['activePageType'] = nextPageType
        updatedUser['activePages'] = activePageIDs
        updatedUser['archivePages'] = archivePageIDs
        dispatch({type: actionTypes.UPDATE_USER,user: updatedUser})
        dispatch({type: actionTypes.COMMIT_DATA,data: updatedData})

        // Commit MongoDB
        api.deletePage(pageID, {user: user})
        .then(res => {
            console.log('Page deleted')
        })
        .catch(err => {
            console.log('Page not deleted', err)
            dispatch({type: actionTypes.ERROR, error: 'Page note created', data: oldData.toJS()})
        })
    }
}

/////////
// TAG //
/////////
export const createTag = (tag, data) => {
    const debug = false
    let updatedData = {...data}
    let updatedTag = {...tag}
    
    return dispatch => {
        const tagID = tag['tagID'] || new ObjectId().toString();
        updatedTag['tagID'] = tagID
        updatedTag['_id'] = tagID
        updatedData['tags'][tagID] = updatedTag
        dispatch({type: actionTypes.COMMIT_DATA, data: updatedData})
        api.createTag(tag)
        .then(tagRes => {
            debug && console.log('[createTag] Completed')
        })
        .catch(err => {
            console.log('[createTag] Failed')
        })
    }
}

export const updateTag = (tag, data) => {
    let updatedData = {...data}
    let updatedTag = {...tag}
    const tagID = tag['tagID']

    return dispatch => {
        api.updateTag(tagID, {updates: {...updatedTag}})
        .then(tagRes => {
            console.log('Tag updated')
            updatedData['tags'][tagID] = new Tag(updatedTag)
            dispatch({type: actionTypes.COMMIT_DATA, data: updatedData})
        })
        .catch(err => {
            console.log('Tag not updated')
        })
    }
}

export const deleteTag = (tagID, data) => {
    let updatedData = {...data}
    return dispatch => {
        api.deleteTag(tagID)
        .then(tagRes => {
            console.log('Tag deleted')
            delete updatedData['tags'][tagID]
            dispatch({type: actionTypes.COMMIT_DATA, data: updatedData})
        })
        .catch(err => {
            console.log('Tag not deleted')
        })
    }
}

///////////
// FOCUS //
///////////
export const getFocus = (userID) => {    
    return dispatch => {
        const body = {filters: {userID: userID}}
        api.getFocus(body)
        .then(res => {
            const data = res.data.data
            let focusData = {}
            data && Object.values(data).map(f => {
                let focus = new Focus(f)
                focus['focusID'] = f._id
                const date = format(new Date(focus['date']), 'LLL d Y')
                focusData[date] = focus
            })
            console.log('Get focus', focusData)
            dispatch({type: actionTypes.GET_FOCUS, focus: focusData})
        })
        .catch(err => {
            console.log('Get focus but no data')
            dispatch({type: actionTypes.ERROR, error: 'Focus not retrieved'})
        })
    }
}

export const createFocus = (focus, data) => {
    let updatedData = {...data} || {}
    const focusID = new ObjectId().toString();
    let updatedFocus = {...focus}
    updatedFocus['focusID'] = focusID
    updatedFocus['_id'] = focusID
    console.log(updatedFocus['date'])
    const date = format(new Date(updatedFocus['date']), 'LLL d Y')
    updatedData[date] = new Focus(updatedFocus)

    return dispatch => {
        dispatch({type: actionTypes.CREATE_FOCUS, data: updatedData})

        api.createFocus({...updatedFocus})
        .then(res => {
            console.log('Focus created')
        })
        .catch(err => {
            dispatch({type: actionTypes.ERROR, error: 'Focus not created'})
        })
    }
}

export const updateFocus = (focus, data) => {
    let updatedData = {...data}
    return dispatch => {
        updatedData[focus['date']] = focus
        dispatch({type: actionTypes.UPDATE_FOCUS, data: updatedData})

        api.updateFocus(focus['focusID'], {...focus})
        .then(res => {
            console.log('Focus updated')
        })
        .catch(err => {
            console.log('Focus not updated')
        })
        
    }
}

export const forwardFocus = (from, to, data, uid) => {
    return dispatch => {
        const create = data['focus'][to] ? false : true
        let updatedFocus = {...data['focus']}
        let fromFocus = data['focus'][from]
        let toFocus = data['focus'][to] || new Focus({date: to, userID: uid})
        if(fromFocus){
            const incomplete = Object.values(_.omitBy(fromFocus['items'], (itemID) => data['items'][itemID]['status'] === itemContext.STATUS.COMPLETED))
            const completed = Object.values(_.omitBy(fromFocus['items'], (itemID) => data['items'][itemID]['status'] === itemContext.STATUS.INCOMPLETE))
            toFocus['items'].push(...incomplete)
            fromFocus['items'] = completed
            updatedFocus[from] = fromFocus
            updatedFocus[to] = toFocus
    
            if(incomplete.length > 0){
                api.updateFocus(fromFocus['focusID'], {...fromFocus})
                .then(fromRes => {
                    if(create){
                        return api.createFocus({...toFocus})
                    } else {
                        return api.updateFocus(toFocus['focusID'], {...toFocus})
                    }
                })
                .then(toRes => {
                    const toFocusID = toRes.data.id
                    toFocus['focusID'] = toFocusID
                    updatedFocus[to] = toFocus
                    dispatch({type: actionTypes.UPDATE_FOCUS, focus: updatedFocus})
                })
                .catch(err => {
                    dispatch({type: actionTypes.ERROR, error: 'Focus not forwarded'})
                })
                console.log(updatedFocus)
                dispatch({type: actionTypes.UPDATE_FOCUS, focus: updatedFocus})
            } else {
                dispatch({type: actionTypes.ERROR, error: 'No incomplete items to forward'})
            }
        } else {
            dispatch({type: actionTypes.ERROR, error: 'No incomplete items to forward'})
        }
    }
}

//////////////
// SCHEDULE //
//////////////
export const forwardSchedule = (oldDate, events, data, uid, sessionId) => {
    const debug = false
    const updatedBy = [uid,sessionId].join('@')
    const oldData = fromJS(data)
    let updatedData = {...data}
    let newDate = moment(oldDate).add(1, 'days').format('MMM D Y')
    oldDate = oldDate.format('MMM D Y')
    debug && console.log('[db.js] forwardSchedule', {new: newDate, old: oldDate, data})

    let updatedAlerts = []
    let updatedItems = []

    // 1. Find items to forward
    let forwardItems = []

    events.map(event => {
        const item = event['item']
        if(item['status'] === 'INCOMPLETE'){
            const start = event['start'] && event['start'].format('MMM D Y')
            const end = event['end'] && event['end'].format('MMM D Y')
            if(start === oldDate || end === oldDate){
                forwardItems.push(item)
            }
        }
    })
    forwardItems.map(item => {
        // 3. Update alerts
        updatedAlerts = item['alerts'].map(alertID => (updatedData['alerts'][alertID]))
        updatedAlerts.map(alert => {
            let updatedAlert = alert
            let option = {}
            option[alert.metric] = alert.value
            const updatedAlertDate = sub(add(new Date(oldDate), {days: 1}), option)
            updatedAlert['date'] = updatedAlertDate
            updatedAlert['subtitle'] = updatedAlert.datetimeString()
            updatedAlerts[alert['alertID']] = updatedAlert
        })

        // 4. Update items
        const upperBound = item['end_date'] && new Date(item['end_date'])
        const lowerBound = item['start_date'] && new Date(item['start_date'])
        newDate = add(new Date(oldDate), {days: 1})   

        let end_date = item['end_date'] && moment(item['end_date'])
        let end_time = item['end_time'] && moment(item['end_time'])
        let start_date = item['start_date'] && moment(item['start_date'])
        let start_time = item['start_time'] && moment(item['start_time'])
        if(!isEqual(upperBound, lowerBound)){
            if(isAfter(add(new Date(oldDate), {days: 1}), upperBound)){
                // Bring forward upper bound
                end_date && end_date.add({days: 1})
                end_time && end_time.add({days: 1})
            } else if(lowerBound) {
                // Bring forward lower bound
                start_date && start_date.add({days: 1})
                start_time && start_time.add({days: 1})

            }
        } else {
            if(isAfter(add(new Date(oldDate), {days: 1}), lowerBound)) {
                // Bring forward lower bound
                start_date && start_date.add({days: 1})
                start_time && start_time.add({days: 1})

                // Bring forward upper bound
                end_date && end_date.add({days: 1})
                end_time && end_time.add({days: 1})
            }
        }


        let updatedItem = new Item({...item})
        updatedItem['end_date'] = end_date
        updatedItem['end_time'] = end_time
        updatedItem['start_date'] = start_date
        updatedItem['start_time'] = start_time
        updatedData['items'][item['itemID']] = updatedItem
        updatedItems.push(updatedItem)
    })

    // 5. Commit MongoDB
    return dispatch => {
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        Promise.all([
            updatedAlerts.length > 0 && updatedAlerts.map(alert => {api.updateAlert(alert['alertID'],{updates: {...alert}})}),
            updatedItems.length > 0 && updatedItems.map(item => {api.updateItem(item['itemID'], {userId: uid, updates: {updatedBy: updatedBy, start_date: item['start_date'], start_time: item['start_time'], end_date: item['end_date'], end_time: item['end_time']}})})
        ])
        .then(res => {
            console.log('Schedule forwarded')
        })
        .catch(err => {
            console.log('Schedule not forwarded', err)
            dispatch({type: actionTypes.ERROR, error: 'Schedule not updated', data: oldData.toJS()})
        })
    }
}

export const loadDates = (dates, data, userId) => {
    let updatedData = {...data}
    let dateRef = dates.map(date => new Date(date))
    const lower = moment(min(dateRef)).startOf('day').toISOString()
    const upper = moment(max(dateRef)).endOf('day').toISOString()
    console.log('[loadDates]', {dates, data, userId, lower, upper})
    return dispatch => {
        api.getItems({
            logic: 'OR',
            userID: userId,
            filters: {
                createdBy: userId,
                start_date: {"$gte": lower, "$lte": upper},
                end_date: {"$gte": lower, "$lte": upper},
            }
        })
        .then(itemRes => {
            itemRes.data['items'].forEach(item => {
                updatedData['items'][item['_id']] = new Item(item)
            })
            dispatch({
                type: actionTypes.UPDATE_DATA,
                data: updatedData,
                loadedDates: dates
            })
        })
        
    }
}

export const loadItems = (data, query, callback) => {
    let updatedData = {...data}
    console.log('[loadItems]',{query})
    return dispatch => {
        api.getItems(query)
        .then(itemRes => {
            const items = itemRes.data['items']
            console.log({items})
            items.forEach(item => {
                updatedData['items'][item['_id']] = new Item(item)
            })
            dispatch({
                type: actionTypes.UPDATE_DATA,
                data: updatedData
            })
            callback && callback({success: true})
        })
        .catch(itemErr => {
            callback && callback({success: false})
        })
    }
}